import React from 'react';

const IconPaymentAmex: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.625 0H2.375C1.06875 0 0 1.02857 0 2.28571V21.7143C0 22.9714 1.06875 24 2.375 24H35.625C36.9313 24 38 22.9714 38 21.7143V2.28571C38 1.02857 36.9313 0 35.625 0Z"
      fill="#3498D8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.12727 12.6909H10.8727L9.99999 10.5091L9.12727 12.6909ZM33.4545 8.54544H28.9818L27.8909 9.74544L26.9091 8.54544H17.4182L16.5454 10.5091L15.6727 8.54544H11.8545V9.41817L11.4182 8.54544H8.14545L4.98181 16.1818H8.79999L9.23636 14.9818H10.3273L10.7636 16.1818H15.0182V15.3091L15.3454 16.1818H17.5273L17.8545 15.2V16.1818H26.5818L27.6727 14.9818L28.6545 16.1818H33.1273L30.2909 12.3636L33.4545 8.54544ZM20.2545 15.0909H19.0545V10.8363L17.2 15.0909H16.1091L14.2545 10.8363V15.0909H11.7454L11.3091 13.8909H8.6909L8.25454 15.0909H6.83636L9.12727 9.63635H10.9818L13.0545 14.7636V9.63635H15.1273L16.7636 13.3454L18.2909 9.63635H20.3636V15.0909H20.2545ZM31.0545 15.0909H29.4182L28 13.2363L26.3636 15.0909H21.4545V9.63635H26.4727L28 11.3818L29.6364 9.63635H31.1636L28.7636 12.3636L31.0545 15.0909ZM22.6545 10.7273V11.7091H25.3818V12.8H22.6545V13.8909H25.7091L27.1273 12.2545L25.8182 10.7273H22.6545Z"
      fill="white"
    />
  </svg>
);

export default IconPaymentAmex;
